/**
 * View codes for the logic app.
 *
 * These mirror `domain-logic`'s `LogicView` enum exactly — the strings are the
 * contract with `AccountDTO.view_codes`, so they must not drift. Kept as a
 * const object rather than a TS enum so the values stay plain strings.
 */
export const LogicView = {
  HOME: "LOGIC_HOME",
  ARTWORKS: "LOGIC_ARTWORKS",
  PRODUCT: "LOGIC_PRODUCT",
  PRODUCT_CATEGORY: "LOGIC_PRODUCT_CATEGORY",
  ORDERS: "LOGIC_ORDERS",
  PRODUCTION_JOB: "LOGIC_PRODUCTION_JOB",
  PRODUCTION_LEGACY_JOB: "LOGIC_PRODUCTION_LEGACY_JOB",
  PRODUCTION_CENTER: "LOGIC_PRODUCTION_CENTER",
  COLLECTION_COLLECTIONS: "LOGIC_COLLECTION_COLLECTIONS",
  COLLECTION_DISPLAY: "LOGIC_COLLECTION_DISPLAY",
  COLLECTION_SHOPIFY: "LOGIC_COLLECTION_SHOPIFY",
  CONFIG_PUBLISHER: "LOGIC_CONFIG_PUBLISHER",
  CONFIG_PUBLISHER_METADATA_TEMPLATES: "LOGIC_CONFIG_PUBLISHER_METADATA_TEMPLATES",
  CONFIG_CATALOG: "LOGIC_CONFIG_CATALOG",
  CONFIG_DECOR: "LOGIC_CONFIG_DECOR",
  CONFIG_STORE: "LOGIC_CONFIG_STORE",
  CONFIG_CLIENT: "LOGIC_CONFIG_CLIENT",
  CONFIG_PRINT_SETTINGS: "LOGIC_CONFIG_PRINT_SETTINGS",
  CONFIG_SKU_MATCH: "LOGIC_CONFIG_SKU_MATCH",
  JOLISCREEN_IMAGES: "LOGIC_JOLISCREEN_IMAGES",
  ADMIN_ACCOUNTS: "LOGIC_ADMIN_ACCOUNTS",
} as const;

export type LogicViewCode = (typeof LogicView)[keyof typeof LogicView];
